export default [
    {
        path: 'customers',
        name: 'admin.customers.index',
        component: require('@/views/admin/customers/index').default,
        meta: {
            auth: {
                roles: ['manage-customers']
            }
        }
    },
    {
        path: 'customers/create',
        name: 'admin.customers.create',
        component: require('@/views/admin/customers/form').default,
        meta: {
            mode: 'create',
            auth: {
                roles: ['manage-customers']
            }
        }
    },

    {
        path: 'participants',
        name: 'admin.participants.index',
        component: require('@/views/admin/customers/participants').default,
    },

    {
        path: 'customers/:id',
        name: 'admin.customers.edit',
        component: require('@/views/admin/customers/form').default,
        meta: {
            mode: 'edit',
            auth: {
                roles: ['manage-customers']
            }
        }
    },
]